import ListSubheader from '@material-ui/core/ListSubheader';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import * as React from 'react';

export interface IStickyListSubheaderProps extends React.PropsWithChildren<any> {
  label: React.ReactNode;
  secondaryAction?: React.ReactNode;
  style?: React.CSSProperties;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    display: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      display: 'flex',
      paddingRight: theme.spacing(0.5)
    },
    flexGrow: {
      flexGrow: 1
    },
    flexShrink: {
      flexShrink: 0
    },
    listSection: {
      backgroundColor: 'inherit'
    },
    ul: {
      backgroundColor: 'inherit',
      listStyleType: 'none',
      padding: 0
    }
  })
);

let StickyListSubheader: React.FunctionComponent<IStickyListSubheaderProps> = ({
  children,
  label,
  secondaryAction,
  style
}) => {
  const classes = useStyles();

  return (
    <li className={classes.listSection} style={style}>
      <ul className={classes.ul}>
        <ListSubheader className={classes.display}>
          <span className={classes.flexGrow}>{label}</span>
          {secondaryAction}
        </ListSubheader>
        {children}
      </ul>
    </li>
  );
};

StickyListSubheader = React.memo<IStickyListSubheaderProps>(StickyListSubheader);
export { StickyListSubheader };
